import { render } from "./ConversationListMessage.vue?vue&type=template&id=552110ca&scoped=true"
import script from "./ConversationListMessage.vue?vue&type=script&lang=js"
export * from "./ConversationListMessage.vue?vue&type=script&lang=js"

import "./ConversationListMessage.vue?vue&type=style&index=0&id=552110ca&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-552110ca"]])

export default __exports__